export default function generateAvatar(first_name, last_name) {
  if (first_name)
    return `https://ui-avatars.com/api/?name=${first_name}+${last_name}&background=random&size=128`;
  else
    return "https://toppng.com/uploads/preview/app-icon-set-login-icon-comments-avatar-icon-11553436380yill0nchdm.png";
}
